import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"margin":"0 auto","padding":"30px"} }

import { withDefaults, reactive, ref } from 'vue';
import {
  BaseButton,
  BaseDialog,
  BaseForm,
  BaseFormItem,
  BaseFormRef,
  BaseUpload,
  XrkMessage,
  BaseInput
} from 'xrk-components';
import { uploadApi } from '@data-source/common/apis';
import { activityDetail, uploadActivityFile } from '../data-source/apis';

// 表单实例

export default /*#__PURE__*/_defineComponent({
  __name: 'activity-upload-file',
  props: {
    remove: { type: Function, default() {
      return () => ({});
    } },
    activityId: { default: null }
  },
  emits: ['success'],
  setup(__props: any, { emit: __emit }) {

const formRef = ref<BaseFormRef>(null);
// upload上传
const upload = ref(null);
const fileList = ref([]);
// 声明 prop 属性
const props = __props;
const emits = __emit;

const form = reactive<{
  folderName: string; //文件夹名称
}>({
  folderName: ''
});

const httpRequest = ({ file }) => {
  return uploadApi({ file });
};
const onError = errorInfo => {
  XrkMessage.error(errorInfo.msg);
};
const onCancel = () => {
  props.remove();
};

const initData = async () => {
  const { data } = await activityDetail({ activityId: props.activityId });
  form.folderName = data.folderName;
  fileList.value = data.fileList.map(item => {
    return {
      name: item.fileName,
      url: item.fileUrl
    };
  });
};
initData();

const onConfirm = async () => {
  await formRef.value.validate();
  if (!fileList.value.length) {
    XrkMessage.error('请上传文件！');
    return;
  }
  await uploadActivityFile({
    activityId: props.activityId,
    folderName: form.folderName,
    activityAttachmentInDTO: fileList.value.map(item => {
      return {
        activityId: props.activityId,
        fileName: item.name,
        fileUrl: item.url
      };
    })
  });
  emits('success');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    visible: true,
    "model-value": true,
    "show-close": true,
    "close-on-press-escape": true,
    "close-on-click-modal": false,
    title: "上传附件",
    width: "420px"
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), {
        onClick: onCancel,
        type: "default"
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseButton), {
        click: onConfirm,
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode("确认")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(BaseForm), {
          ref_key: "formRef",
          ref: formRef,
          model: form,
          "label-width": "auto",
          "label-position": "right"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseFormItem), {
              rules: [{ required: true, message: '文件夹名称不能为空' }],
              label: "文件夹名称：",
              prop: "folderName"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  modelValue: form.folderName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.folderName) = $event)),
                  placeholder: "请输入文件夹名称",
                  maxlength: "30",
                  "show-word-limit": true
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              label: "",
              prop: ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_unref(BaseUpload), {
                    ref_key: "upload",
                    ref: upload,
                    fileList: fileList.value,
                    "onUpdate:fileList": _cache[1] || (_cache[1] = ($event: any) => ((fileList).value = $event)),
                    style: {"width":"360px"},
                    "http-request": httpRequest,
                    "auto-upload": true,
                    multiple: false,
                    accept: [
                '.xls',
                '.xlsx',
                '.zip',
                '.doc',
                '.docx',
                '.ppt',
                '.pptx',
                '.pdf',
                '.png',
                '.jpg'
              ],
                    limit: 6,
                    "limit-size": 60,
                    drag: true,
                    onError: onError,
                    btnText: "点击上传"
                  }, {
                    tip: _withCtx(() => [
                      _createTextVNode(" 支持上传zip、xls、xlsx、doc、docx、ppt、pptx、pdf、png、jpg格式文件，且不超过60M。 ")
                    ]),
                    _: 1
                  }, 8, ["fileList"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ]),
    _: 1
  }))
}
}

})